import React, { useEffect, useState } from "react";

const API = process.env.REACT_APP_API_URL || "";

async function fetchLangages() {
  const res = await fetch(`${API}/api/langage_stats`);
  return await res.json();
}

async function saveLangage(id, form) {
  const res = await fetch(`${API}/api/langage_lgas/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/merge-patch+json" },
    body: JSON.stringify(form),
  });
  if (!res.ok) throw new Error("Erreur lors de la modification");
}

async function createLangage(form) {
  const res = await fetch(`${API}/api/langage_lgas`, {
    method: "POST",
    headers: { "Content-Type": "application/ld+json" },
    body: JSON.stringify(form),
  });
  if (!res.ok) throw new Error("Erreur lors de la création");
}

async function deleteLangage(id) {
  const res = await fetch(`${API}/api/langage_lgas/${id}`, { method: "DELETE" });
  if (!res.ok) throw new Error("Erreur lors de la suppression");
}

const emptyForm = { lgaLibJo: "", lgaLibCrit: "" };

function EditRow({ langage, onSave, onCancel }) {
  const [form, setForm] = useState({
    lgaLibJo: langage.lgaLibJo || "",
    lgaLibCrit: langage.lgaLibCrit || "",
  });

  const inputStyle = { width: "100%", padding: "4px 8px", borderRadius: 4, border: "1px solid #555", background: "#2a2a2a", color: "white" };

  return (
    <tr className="bg-dark">
      <td colSpan="4">
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, padding: "10px 0" }}>
          <div>
            <label style={{ color: "white", fontSize: 12, fontWeight: 600 }}>Libellé JO</label>
            <input style={inputStyle} value={form.lgaLibJo} onChange={e => setForm({ ...form, lgaLibJo: e.target.value })} />
          </div>
          <div>
            <label style={{ color: "white", fontSize: 12, fontWeight: 600 }}>Libellé critère</label>
            <input style={inputStyle} value={form.lgaLibCrit} onChange={e => setForm({ ...form, lgaLibCrit: e.target.value })} />
          </div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button className="fr-btn" onClick={() => onSave(langage.lgaId, form)}>Enregistrer</button>
          <button className="fr-btn--secondary" onClick={onCancel}>Annuler</button>
        </div>
      </td>
    </tr>
  );
}

function AddRow({ onSave, onCancel }) {
  const [form, setForm] = useState(emptyForm);
  const inputStyle = { width: "100%", padding: "4px 8px", borderRadius: 4, border: "1px solid #ccc" };

  return (
    <tr style={{ background: "#f0f9ff" }}>
      <td colSpan="4">
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, padding: "10px 0" }}>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600 }}>Libellé JO</label>
            <input style={inputStyle} placeholder="ex: courant" value={form.lgaLibJo} onChange={e => setForm({ ...form, lgaLibJo: e.target.value })} />
          </div>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600 }}>Libellé critère</label>
            <input style={inputStyle} placeholder="ex: courant" value={form.lgaLibCrit} onChange={e => setForm({ ...form, lgaLibCrit: e.target.value })} />
          </div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button className="fr-btn" onClick={() => onSave(form)}>Créer</button>
          <button className="fr-btn--secondary" onClick={onCancel}>Annuler</button>
        </div>
      </td>
    </tr>
  );
}

export default function LangageList() {
  const [langages, setLangages] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [adding, setAdding] = useState(false);
  const [search, setSearch] = useState("");
  const [message, setMessage] = useState(null);

  const load = async () => {
    const data = await fetchLangages();
    setLangages(data);
  };

  useEffect(() => { load(); }, []);

  const notify = (msg) => {
    setMessage(msg);
    setTimeout(() => setMessage(null), 3000);
  };

  const handleSave = async (id, form) => {
    try {
      await saveLangage(id, form);
      setEditingId(null);
      load();
      notify("✅ Niveau de langue modifié");
    } catch (e) {
      notify("❌ " + e.message);
    }
  };

  const handleCreate = async (form) => {
    try {
      await createLangage(form);
      setAdding(false);
      load();
      notify("✅ Niveau de langue créé");
    } catch (e) {
      notify("❌ " + e.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer ce niveau de langue ?")) return;
    try {
      await deleteLangage(id);
      load();
      notify("✅ Niveau de langue supprimé");
    } catch (e) {
      notify("❌ " + e.message);
    }
  };

  const filtered = langages.filter(l =>
    [l.lgaLibJo, l.lgaLibCrit].some(v => (v || "").toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div className="admin-page">
      <div className="row w-full admin-page-header">
        <div className="col">
          <h2 className="card-title mb-0">Gestion des niveaux de langue</h2>
          <p className="text-secondary m-0">{langages.length} niveau(x) enregistré(s) — {langages.filter(l => l.nbTermes === 0).length} supprimable(s)</p>
        </div>
        <div className="col-md-auto col-sm-12">
          <div className="ms-auto d-flex flex-wrap btn-list" style={{ gap: 8 }}>
            <div className="input-group input-group-flat w-auto">
              <span className="input-group-text">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-1">
                  <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
                  <path d="M21 21l-6 -6"></path>
                </svg>
              </span>
              <input type="text" className="form-control" placeholder="Rechercher..." value={search} onChange={e => setSearch(e.target.value)} autoComplete="off" />
            </div>
            <button className="fr-btn" onClick={() => { setAdding(true); setEditingId(null); }}>
              + Nouveau
            </button>
          </div>
        </div>
      </div>

      {message && (
        <div style={{ marginBottom: 12, padding: "8px 14px", borderRadius: 6, background: message.startsWith("✅") ? "#dcfce7" : "#fee2e2", color: message.startsWith("✅") ? "#166534" : "#991b1b" }}>
          {message}
        </div>
      )}

      <div className="table-responsive">
        <table className="table table-vcenter table-selectable">
          <thead>
            <tr>
              <th className="admin-table-th">Libellé JO</th>
              <th className="admin-table-th">Libellé critère</th>
              <th className="admin-table-th">Fiches</th>
              <th className="admin-table-th">Actions</th>
            </tr>
          </thead>
          <tbody>
            {adding && (
              <AddRow onSave={handleCreate} onCancel={() => setAdding(false)} />
            )}
            {filtered.map(l => (
              <React.Fragment key={l.lgaId}>
                <tr>
                  <td className="admin-table-td"><span style={{ fontWeight: 600 }}>{l.lgaLibJo}</span></td>
                  <td className="admin-table-td">{l.lgaLibCrit}</td>
                  <td className="admin-table-td">
                    <span style={{ fontSize: 13, color: "#374151" }}>
                      {l.nbFiches > 0 ? l.nbFiches : "—"}
                    </span>
                  </td>
                  <td className="admin-table-td" style={{ whiteSpace: "nowrap" }}>
                    <span style={{ fontSize: 11, color: "#6b7280", marginRight: 8 }}>
                      {l.nbTermes > 0 ? `${l.nbTermes} terme(s)` : "—"}
                    </span>
                    <button className="fr-btn--secondary" onClick={() => { setEditingId(l.lgaId); setAdding(false); }}>
                      Modifier
                    </button>
                    {l.nbTermes === 0 && (
                      <button className="fr-btn--danger" style={{ marginLeft: 6 }} onClick={() => handleDelete(l.lgaId)}>
                        Supprimer
                      </button>
                    )}
                  </td>
                </tr>
                {editingId === l.lgaId && (
                  <EditRow langage={l} onSave={handleSave} onCancel={() => setEditingId(null)} />
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
